import { render, staticRenderFns } from "./dialogBatchSetLeader.vue?vue&type=template&id=6085fdea&scoped=true&"
import script from "./dialogBatchSetLeader.vue?vue&type=script&lang=js&"
export * from "./dialogBatchSetLeader.vue?vue&type=script&lang=js&"
import style0 from "./dialogBatchSetLeader.vue?vue&type=style&index=0&id=6085fdea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6085fdea",
  null
  
)

export default component.exports